import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import 'javascripts/nav_auto_scroll.js'
import { jqTextCopy, scrollGallery, videoModal } from 'javascripts/general_scripts';
import {initGoogleCharts} from 'javascripts/utils/googleCharts';
import { comparisonWidget } from "javascripts/product_comparisons/comparison_widget";

jqTextCopy();
scrollGallery();
videoModal();

document.addEventListener('DOMContentLoaded', comparisonWidget);

// Adding this because the anchor links fall on different locations
// when clicking directly on the page and clicking from one of the other tabs
$('.nav-link[href="#pricing"], .nav-link[href="#reviews-container"]').click(function() {
    let id = $(this).attr('href');
    $(id).css('top', '-120px')
});

$('.summary-toggle').click(() => document.getElementById('review-link-for-summaries-anchor').scrollIntoView(true));


let chartData = [{
    id: 'co_size_reviewers',
    colors: 'default'
}, {
    id: 'co_size_visitors',
    colors: 'default'
}, {
    id: 'market_share',
    colors: 'yellow'
}]

const drawChart = initGoogleCharts(chartData, 'pie');

Turbo.StreamActions.refreshMarketShareChart = function () {
    drawChart();
};
